import React from 'react'

import { IconProps } from '../types'

export const UpArrow = ({ className, width = 18, height = 9, fill }: IconProps) => (
  <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 18 9">
    <path d="M8.99993 0L17.4852 8.48528C11.8284 8.48528 6.1715 8.48528 0.514648 8.48528L8.99993 0Z" />
  </svg>
)
